import React from "react";
import Header from "../../components/header";
import StoryMenu from "../../components/story/menu";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";

const StoryTimeLine = () => {
  const navigate = useNavigate();
  const timelineRefs = useRef({});

  // 페이지 진입 시 저장된 스크롤 위치로 이동
  useEffect(() => {
    const savedScrollPosition = sessionStorage.getItem('timeline-scroll-position');
    const savedSequenceId = sessionStorage.getItem('timeline-sequence-id');
    
    if (savedScrollPosition && savedSequenceId) {
      setTimeout(() => {
        const element = timelineRefs.current[savedSequenceId];
        if (element) {
          element.scrollIntoView({ 
            behavior: 'auto', 
            block: 'center' 
          });
        } else {
          window.scrollTo(0, parseInt(savedScrollPosition));
        }
        
        sessionStorage.removeItem('timeline-scroll-position');
        sessionStorage.removeItem('timeline-sequence-id');
      }, 50);
    }
  }, []);

  const handleTestClick = (id) => {
    sessionStorage.setItem('timeline-scroll-position', window.scrollY.toString());
    sessionStorage.setItem('timeline-sequence-id', id.toString());
    
    navigate(`/story/timeline/${id}`);
  };

  const setTimelineRef = (id) => (element) => {
    if (element) {
      timelineRefs.current[id] = element;
    }
  };

  return (
    <div className="min-h-[calc(100vh-70px)] flex flex-col pt-[50px] md:pt-[70px] bg-white h-full">
      <Header selectedMenu={1} />
      <div className="pb-[30px]">
        <StoryMenu subMenuType={1} />
        <div className="text-center w-full">
          <div className="text-lg md:text-2xl font-semibold mb-[5px]">임신초기</div>
          <div className="text-base md:text-lg font-normal mb-10 text-[#c4c4c4]">4주~13주</div>
          
          {/* 초기 시작점 */}
          <div className="w-full h-4 text-center">
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#d9d9d9] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 혈액형 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(0)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-right pr-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(0)}>혈액형 검사</span>
            </div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFF0C2] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 일반 혈액검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(1)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFF0C2] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-left pl-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(1)}>일반 혈액검사</span>
            </div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 풍진 항체 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(2)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-right pr-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(2)}>풍진 항체 검사</span>
            </div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFE189] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 에이즈 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(3)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFE289] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-left pl-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(3)}>에이즈 검사</span>
            </div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 소변 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(4)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-right pr-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(4)}>소변 검사</span>
            </div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFE289] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 자궁 경부암 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(5)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFDC73] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-left pl-4">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(5)}>자궁 경부암 검사</span>
            </div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 성병 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(6)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-right pr-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(6)}>성병 검사</span>
            </div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFDC73] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 질 초음파 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(7)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFDC73] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-left pl-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(7)}>질 초음파 검사</span>
            </div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 태아 목 투명대 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(8)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-right pr-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(8)}>태아 목 투명대 검사</span>
            </div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFD658] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 초음파 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(9)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFD658] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-left pl-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(9)}>초음파 검사<br/>(유방, 갑상선)</span>
            </div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 취약 X 증후군 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(10)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-right pr-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(10)}>취약 X 증후군 검사</span>
            </div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFD658] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 시퀀셜 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(11)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFD658] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-left pl-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(11)}>시퀀셜 검사</span>
            </div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 융모막 생검 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(12)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-right pr-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(12)}>융모막 생검</span>
            </div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFD658] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 초기 종료점 */}
          <div className="w-full h-4 text-center">
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#d9d9d9] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="w-full h-[1px] bg-[#d9d9d9] -mt-[13px]"></div>
          </div>

          <p className="h-[11px] m-0" />
          <p className="h-[11px] m-0" />
          <div className="text-lg md:text-2xl font-semibold mb-[5px]">임신중기</div>
          <div className="text-base md:text-lg font-normal mb-10 text-[#c4c4c4]">14주~28주</div>

          {/* 중기 시작점 */}
          <div className="w-full h-4 text-center">
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#d9d9d9] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 기형아 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(13)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FEC009] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-left pl-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(13)}>기형아 검사</span>
            </div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 쿼드 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(14)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-right pr-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(14)}>쿼드 검사</span>
            </div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FEC009] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 니프티 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(15)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFB422] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-left pl-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(15)}>니프티 검사</span>
            </div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 양수 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(16)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-right pr-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(16)}>양수 검사</span>
            </div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFB422] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 정밀 초음파 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(17)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFB422] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-left pl-4">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(17)}>정밀 초음파 검사</span>
            </div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 태아 심장 초음파 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(18)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-right pr-4">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(18)}>태아 심장 초음파</span>
            </div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFA51E] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 임신성 당뇨 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(19)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FFA51E] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-left pl-4">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(19)}>임신성 당뇨 검사</span>
            </div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 일반 혈액 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(20)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-right pr-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(20)}>일반 혈액 검사</span>
            </div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FF9110] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 입체 초음파 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(21)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FF9110] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-left pl-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(21)}>입체 초음파</span>
            </div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 중기 종료점 */}
          <div className="w-full h-4 text-center">
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#d9d9d9] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="w-full h-[1px] bg-[#d9d9d9] -mt-[13px]"></div>
          </div>

          <p className="h-[11px] m-0" />
          <p className="h-[11px] m-0" />
          <div className="text-lg md:text-2xl font-semibold mb-[5px]">임신후기</div>
          <div className="text-base md:text-lg font-normal mb-10 text-[#c4c4c4]">19주~출산</div>

          {/* 후기 시작점 */}
          <div className="w-full h-4 text-center">
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#d9d9d9] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 태아 안녕 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(22)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-right pr-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(22)}>태아 안녕 검사</span>
            </div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FF9110] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 일반 혈액검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(23)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FF7B01] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-left pl-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(23)}>일반 혈액검사</span>
            </div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* Ab Screening */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(24)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-right pr-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(24)}>Ab Screening</span>
            </div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FF7B01] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* GBS 균 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(25)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FF7B01] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-left pl-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(25)}>GBS 균 검사</span>
            </div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 정밀 초음파 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(26)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-right pr-4">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(26)}>정밀 초음파 검사</span>
            </div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FF6C02] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 내진 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(27)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FF6C02] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-left pl-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(27)}>내진 검사</span>
            </div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 심전도, 흉부 촬영 간기능 검사 */}
          <div className="w-full h-4 text-center" ref={setTimelineRef(28)}>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px] text-right pr-5">
              <span className="cursor-pointer hover:text-blue-500" onClick={() => handleTestClick(28)}>심전도, 흉부 촬영 간기능 검사</span>
            </div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#FF6C02] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base md:text-xl leading-[22px] -mt-[3px]"></div>
          </div>
          <div className="w-[1px] h-20 mx-auto bg-[#d9d9d9]"></div>

          {/* 후기 종료점 */}
          <div className="w-full h-4 text-center">
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="inline-block w-4 h-4 md:w-6 md:h-6 rounded-full bg-[#d9d9d9] align-top"></div>
            <div className="inline-block align-top w-[calc((100%/2)-50px)] text-base leading-[22px] -mt-[3px]"></div>
            <div className="w-full h-[1px] bg-[#d9d9d9] -mt-[13px]"></div>
          </div>

          <p className="h-[11px] m-0" />
          <p className="h-[11px] m-0" />
          <p className="h-[11px] m-0" />
        </div>
      </div>
    </div>
  );
};

export default StoryTimeLine;
